export default __webpack_public_path__ + "media/images/flags/nh-a00b6f314c64552aaadd11075db47546.png";